// extracted by mini-css-extract-plugin
module.exports = {"mqXs":"576px","mqSm":"768px","mqMd":"992px","mqLg":"1200px","mqXl":"1440px","container":"textBlock-module--container--uPXEU"};